// extracted by mini-css-extract-plugin
export default {"observer":"observer_observer__17LlJ","rotate":"observer_rotate__Wsebh"};